module.exports = __webpack_public_path__ + "static/media/pinterest.ae9dc812.svg";